export default __webpack_public_path__ + "static/media/heart.89da2a27.gif";